import { profileActions } from 'src/store/profile/profile.actions';
import { backendUrl } from '../config';
import axiosInstance from '../axios-instance';

export const USE_3X_WORKWEAR_PUNCHOUT = true; // Move this to env if needed

const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const getBrandingClothesUrlWithToken = async (retries = 0) => {
  try {
    const { data } = await axiosInstance.get(`${backendUrl}/api/branding_clothes`);
    // Return both url and token from response
    return data; // This now contains { url: "url", token: "<token>" }
  } catch (e) {
    if (retries < 3) {
      await wait(500);
      return getBrandingClothesUrlWithToken(retries + 1);
    }

    throw e;
  }
};

export const initiateBrandingClothesRedirect = async (e, dispatch, toast, onError, onSuccess, setLoadingState) => {
  let responseData;

  try {
    if (e && typeof e === 'object' && typeof e.preventDefault === 'function') e.preventDefault();
    if (dispatch && typeof dispatch === 'function') dispatch(profileActions.setIsFetchingPunchoutUrl(true));
    responseData = await getBrandingClothesUrlWithToken();
  } catch (e) {
    console.error(e);
    // Reset states in case of error
    if (dispatch && typeof dispatch === 'function') dispatch(profileActions.setIsFetchingPunchoutUrl(false));
    if (setLoadingState && typeof setLoadingState === 'function') setLoadingState(false);
    if (onError && typeof onError === 'function') onError();
    return; // Exit early
  }

  try {
    if (responseData && responseData.url) {
      // Create a form element
      const form = document.createElement('form');
      form.method = 'POST';
      form.action = responseData.url;
      form.target = '_blank';
      form.style.display = 'none';

      // Add token as form data
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'token';
      input.value = responseData.token || '';
      form.appendChild(input);

      // Append to document body and submit
      document.body.appendChild(form);
      form.submit();

      // Clean up the form element after submission
      setTimeout(() => {
        document.body.removeChild(form);
      }, 100);

      // Always reset states after submission - success or not
      if (dispatch && typeof dispatch === 'function') {
        dispatch(profileActions.setIsFetchingPunchoutUrl(false));
      }

      // Reset component's loading state
      if (setLoadingState && typeof setLoadingState === 'function') {
        setLoadingState(false);
      }

      // Call success callback
      if (onSuccess && typeof onSuccess === 'function') {
        onSuccess();
      }

      return; // Exit after successful submission
    }
  } catch (e) {
    console.error(e);
  }

  // If we get here, there was a problem with the URL or the process
  if (dispatch && typeof dispatch === 'function') {
    dispatch(profileActions.setIsFetchingPunchoutUrl(false));
  }

  // Reset component's loading state
  if (setLoadingState && typeof setLoadingState === 'function') {
    setLoadingState(false);
  }

  if (onError && typeof onError === 'function') onError();
  if (toast && typeof toast === 'object' && typeof toast.addError === 'function') {
    toast.addError('Kunne ikke hente URL for profileringstøy');
  }
};
